import { useState } from "react";
import { motion } from "framer-motion";
import { X, Copy, Check, Share2 } from "lucide-react";
import { shareUrl } from "@/lib/api";
import { EDITION_SLUG } from "@/hooks/useEdition";

export const SharePanel = ({ page, edition, ui, onClose }) => {
  const [copied, setCopied] = useState(false);
  const url = shareUrl(EDITION_SLUG, edition.lang, page.n);
  const img = page.image || page.images?.[0]?.src || "/assets/cover_plate.jpg";
  const title = page.title || edition.title;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); } catch { /* fallback below */ }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const native = () => navigator.share?.({ title: `${title} — ROOTS`, text: page.deck || edition.deck, url }).catch(() => {});
  return (
    <motion.div className="overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} data-testid="share-overlay">
      <motion.div className="share-card" initial={{ y: 24, scale: 0.96 }} animate={{ y: 0, scale: 1 }} exit={{ y: 16, opacity: 0 }} transition={{ type: "spring", damping: 26, stiffness: 240 }} onClick={(e) => e.stopPropagation()} role="dialog" aria-label={ui.share} data-testid="share-panel" dir={edition.dir}>
        <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: "1px solid rgba(217,218,221,0.12)" }}>
          <div className="reader-label" style={{ color: "#fff" }}>{ui.share}</div>
          <button className="reader-btn" onClick={onClose} title={ui.close} data-testid="share-close"><X size={18} /></button>
        </div>
        <div style={{ height: 200, overflow: "hidden" }}>
          <img src={img} alt={title} className="w-full h-full object-cover" style={{ objectPosition: "50% 25%" }} data-testid="share-preview-image" />
        </div>
        <div className="p-5">
          <div className="reader-label" style={{ opacity: 0.6 }}>ROOTS · {edition.number} · {ui.page} {page.n}</div>
          <div className="font-head font-semibold text-white mt-1" style={{ fontSize: 22, lineHeight: 1.05 }} data-testid="share-preview-title">{title}</div>
          {page.deck && <p className="font-head italic mt-1" style={{ fontSize: 14, opacity: 0.7 }}>{page.deck}</p>}
          <div className="flex gap-2 mt-4">
            <input className="share-input" readOnly value={url} onFocus={(e) => e.target.select()} data-testid="share-url-input" />
            <button className="btn-bordeaux" style={{ padding: "8px 14px" }} onClick={copy} data-testid="share-copy-btn">
              {copied ? <Check size={13} /> : <Copy size={13} />} {copied ? ui.copied : "Copy"}
            </button>
          </div>
          {typeof navigator !== "undefined" && navigator.share && (
            <button className="btn-silver mt-3 w-full justify-center" onClick={native} data-testid="share-native-btn"><Share2 size={13} /> {ui.share}</button>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};
